import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../services/gaAnalyticsService';

/**
 * Initialises GA4 once and fires a page_view on every route change.
 * Must be used inside a component that is a child of BrowserRouter.
 */
export function useGoogleAnalytics() {
  const location = useLocation();

  // Bootstrap GA once
  useEffect(() => {
    initGA();
  }, []);

  // Track page views on route changes
  useEffect(() => {
    trackPageView(location?.pathname + location?.search);
  }, [location]);
}

export default useGoogleAnalytics;
